import { render, staticRenderFns } from "./JacketCertificationFilters.vue?vue&type=template&id=2b5f744c&scoped=true"
import script from "./JacketCertificationFilters.vue?vue&type=script&lang=js"
export * from "./JacketCertificationFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5f744c",
  null
  
)

export default component.exports